import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Share, BookOpen, Copy, PlusSquare, Glasses, Lock } from "lucide-react";
import { FakePage, Hot, HomeScreen, Sheet, HOST } from "./parts";

const SafariBar = ({ hot }) => (
  <div className="absolute inset-x-0 bottom-0 z-10 bg-slate-50/95 border-t border-slate-200 pb-4 pt-2 px-3 space-y-2">
    <div className="h-7 rounded-lg bg-slate-200/80 flex items-center justify-center gap-1 text-[9px] text-slate-600 overflow-hidden whitespace-nowrap"><Lock className="w-2.5 h-2.5 shrink-0" /><span className="truncate">{HOST}</span></div>
    <div className="flex items-center justify-between text-sky-600 px-1">
      <ChevronLeft className="w-4 h-4" /><ChevronRight className="w-4 h-4 opacity-40" />
      {hot ? <Hot className="p-1"><Share className="w-4 h-4" /></Hot> : <Share className="w-4 h-4" />}
      <BookOpen className="w-4 h-4" /><Copy className="w-4 h-4" />
    </div>
  </div>
);

export const IosShare = () => (<><FakePage /><SafariBar hot /></>);

const Row = ({ icon: Icon, label, hot }) => {
  const body = <span className="flex w-full items-center justify-between px-3 py-2 text-[10px] font-medium bg-white">{label}<Icon className="w-3.5 h-3.5 text-slate-700" /></span>;
  return hot ? <Hot className="w-full rounded-lg overflow-visible">{body}</Hot> : <div className="rounded-lg overflow-hidden">{body}</div>;
};

export const IosSheet = () => (
  <>
    <FakePage dim /><SafariBar />
    <Sheet className="p-3 space-y-2 pb-6">
      <div className="flex items-center gap-2 pb-1"><img src="/icon-192.png" alt="" className="w-7 h-7 rounded-lg" /><div className="text-[10px] font-semibold leading-tight">K Gestionale<div className="text-slate-500 font-normal truncate max-w-[120px]">{HOST}</div></div></div>
      <Row icon={Copy} label="Copia" />
      <Row icon={Glasses} label="Aggiungi a Elenco lettura" />
      <Row icon={PlusSquare} label="Aggiungi alla schermata Home" hot />
    </Sheet>
  </>
);

export const IosAdd = () => (
  <div className="absolute inset-0 bg-slate-100 pt-8">
    <div className="flex items-center justify-between px-3 text-[10px]">
      <span className="text-sky-600">Annulla</span><b>Aggiungi a Home</b>
      <Hot className="px-1.5 py-0.5"><span className="text-sky-600 font-bold">Aggiungi</span></Hot>
    </div>
    <motion.div className="m-3 mt-4 rounded-xl bg-white p-3 flex items-center gap-3" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
      <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl" />
      <div className="flex-1 text-[10px]"><div className="border-b border-slate-200 pb-1 font-medium">K Gestionale</div><div className="text-slate-400 pt-1 truncate max-w-[110px]">{HOST}</div></div>
    </motion.div>
    <div className="absolute inset-x-0 bottom-0 h-28 bg-slate-300/70 grid grid-cols-10 gap-1 p-2 content-start">
      {Array.from({ length: 30 }).map((_, i) => <span key={i} className="h-5 rounded bg-white/90" />)}
    </div>
  </div>
);

export const IosHome = () => <HomeScreen />;
